import React, {useEffect, useRef, useState} from 'react';
import {generateRandomKey} from "../utils/generateRandomKey";

export const Project = (props) => {
    const headerElement = useRef();
    const [showDescription, setShowDescription] = useState(false);
    const {title, description} = props.project;

    const toggleDescription = () => {
        setShowDescription((showDescription) => !showDescription);
    };

    const generateDescription = () => {
        return (
            <div>
               {description.map(paragraph => <p key={generateRandomKey()}>{paragraph}</p>)}
            </div>
        )
    };

    useEffect(() => {
        if (showDescription) {
            headerElement.current.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
    }, [showDescription]);

    return (
        <section className="col-12">
            <h2 onClick={() => toggleDescription()} ref={headerElement}>{title}</h2>
            {showDescription && generateDescription()}
        </section>
    );
};
